module.exports = __webpack_public_path__ + "img/sch3-info.e0f5f2da.png";